export const Tab = {
    friends: "friends",
    requests: "requests",
} as const;
export type Tab = typeof Tab[keyof typeof Tab];
